module.exports = __webpack_public_path__ + "static/img/znjj2660361.png";